import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import community from "../../assets/vector/community-image.png";
import { mouseContext } from "../../context/mouseContext";
import classes from "./RnDCommunity.module.css";

const RnDCommunity = () => {
  const { mouseEnterHandler, mouseLeaveHandler } = useContext(mouseContext);

  return (
    <section className={classes.community} aria-labelledby="rnd-community-title">
      <div className={classes.communityText}>
        <p id="rnd-community-title">
          We are always looking for{" "}
          <span>highly enthusiastic</span> people who can think in unique ways
          and innovate solutions that make a global impact. If you are one of
          them,{" "}
          <NavLink
            to="/careers"
            onMouseEnter={mouseEnterHandler}
            onMouseLeave={mouseLeaveHandler}
            aria-label="Apply for careers at IQApex Labs"
          >
            Apply Now
          </NavLink>{" "}
          to join our{" "}
          <span>impactful Research &amp; Development community</span>.
        </p>
      </div>

      <div className={classes.communityImage}>
        <img
          src={community}
          alt="Research and Development community collaboration"
          loading="lazy"
        />
      </div>
    </section>
  );
};

export default RnDCommunity;
